import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import * as echarts from "echarts";
import VueSignaturePad from 'vue-signature-pad'
// import store from './js/store.js';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'; // 引入 Swiper 的 CSS 文件
import errorHandler from '@/utils/errorHandler'
import { getFullUrl } from '@/utils/showImg';
import { isEmpty } from './utils/common'
import timeUtil from './utils/timeUtil'
import desensitization from './utils/desensitization'
import store from './store'
Vue.prototype.$getFullUrl = getFullUrl;
Vue.prototype.$desensitization = desensitization;
Vue.prototype.$timeUtil = timeUtil;
Vue.prototype.$isEmpty = isEmpty;
Vue.use(VueAwesomeSwiper);
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueSignaturePad)
Vue.use(errorHandler)
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})
new Vue({
  store,
  router,
  render: function (h) { return h(App) }
}).$mount('#app')



